import de from './de.json';
import en from './en.json';

export const languages = { de, en };



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/languages/index.js